import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectRateSheets = createSelector(selectLoanApplication, ({ rateSheets }) => rateSheets);

const selectRateSheetsValues = createSelector(selectRateSheets, Object.values);

export const selectSortedRateSheets = createSelector(selectRateSheetsValues, rateSheets =>
  rateSheets.sort((a, b) => new Date(b.dateUploaded) - new Date(a.dateUploaded)),
);
